declare global {
  interface Date {
    $toDateTimeString(considerTheTimezone?: boolean): string;
    $toDateTimeUTC(): string;
    $toDateTime(considerTheTimezone?: boolean): {date: string; time: string};
  }
}

/**
 * Перетворює дату в рядок формату "YYYY-MM-DD HH:mm:ss"
 * @param considerTheTimezone - якщо true, враховує часовий пояс при форматуванні (за замовчуванням: true)
 * @returns рядок у форматі "YYYY-MM-DD HH:mm:ss"
 */
Date.prototype.$toDateTimeString = function (considerTheTimezone = true): string {
  const {date, time} = this.$toDateTime(considerTheTimezone);

  return [date, time].join(' ');
};
Date.prototype.$toDateTimeUTC = function (): string {
  const {date, time} = this.$toDateTime(false);

  return [date, time].join('T');
};
/**
 * Перетворює дату в об'єкт з окремими полями для дати та часу
 * @param considerTheTimezone - якщо true, враховує часовий пояс при форматуванні (за замовчуванням: true)
 * @returns об'єкт з полями date (YYYY-MM-DD) та time (HH:mm:ss)
 */
Date.prototype.$toDateTime = function (considerTheTimezone = true): {date: string; time: string} {
  let offsetMs = 0;
  if (considerTheTimezone) {
    offsetMs = this.getTimezoneOffset() * 60 * 1000; // Offset in milliseconds
  }
  const localDate = new Date(this.getTime() - offsetMs); // We are correcting the date

  const [d, t] = localDate.toISOString().slice(0, -1).split('T');

  return {
    date: d,
    time: t.split('.')[0],
  };
};
export {}; // So that TypeScript recognizes the file as a module and the extension works.
